import { render } from "./ManageCompanyPage.vue?vue&type=template&id=365ab6d2"
import script from "./ManageCompanyPage.vue?vue&type=script&lang=js"
export * from "./ManageCompanyPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__